import {
  EtisArrestExportRow,
  EtisArrestsExportPage,
} from '@/api/caseTable/EtisArrestsExport';

/**
 * Type of result of importing a single row of ETIS import files.
 *
 * NB: Same as EtisArrestImporter::RESULT_* in back-end!
 */
export enum EtisArrestImportRowResultType {
  CREATED = 'created',
  REACTIVATED = 'reactivated',
  SKIPPED = 'skipped',
  FAILED = 'failed',
}

/**
 * Result of importing a single row of ETIS import files.
 */
export type EtisArrestImportRowResult = {
  varaId: string;
  kisAvalduseId: string;
  result: EtisArrestImportRowResultType;
  message: string | null;
};

/**
 * A page of rows of ETIS import files to import, in the same format as
 * returned by the ETIS arrests export.
 */
export type EtisArrestsImportPage = {
  columns: EtisArrestsExportPage['columns'];
  rows: EtisArrestExportRow[];
};
